import React, { useContext, useEffect } from "react";
import { UserContext } from "../../context/userContext";
import ContentDetailsInfluencer from "../../components/ContentDetailsInfluencer/ContentDetailsInfluencer";
import ContentDetailsCompany from "../../components/ContentDetailsCompany/ContentDetailsCompany";
import { getConvertCurrency } from "../../api/exchangeApi";
import { useState } from "react";
import { CurrencyContext } from "../../context/currencyContext";
import { formatNumber } from "../../services/generalSevices";
import { LangContext } from "../../context/langContext";

export default function CollaborationContent({ item, setShowDispute, setActiveIndex, setShowCarousel, setContentIndex, contentIndex, setContentType }) {

    const { userType } = useContext(UserContext);
    const { currency } = useContext(CurrencyContext);
    const { locale } = useContext(LangContext);
    const auxCurrency = currency.symbol;

    const [contentPrice, setContentPrice] = useState(null);

    useEffect(() => {
        getConvertCurrency({ amount: item.price }).then((response) => {
            //setContentPrice(response[auxCurrency].toFixed(0))
            setContentPrice(response[auxCurrency].toFixed(2))
        })
    }, [currency])

    return (<tr>
        <td >
            <div className="collaborationItem">{(locale === 'es-CO') ? (JSON.parse(item.title).nombre) : (JSON.parse(item.title).name)} x {item.data.length}
            </div>
        </td>

        <td>
            <p className="unitPrice"><span>$ </span>{formatNumber(contentPrice)}</p>
            {/* <p className="subtotal">$ {formatNumber(contentPrice * item.data.length)}</p> */}
        </td>

        <td>
            {(userType === 'influencer') &&

                (item.data.map((subItem, index) => {
                    return (
                        <ContentDetailsInfluencer subItem={subItem} type={JSON.parse(item.title).name.split(' ')[0]} setShowDispute={setShowDispute} activeIndex={index} setActiveIndex={setActiveIndex} setShowCarousel={setShowCarousel} setContentIndex={setContentIndex} contentIndex={contentIndex} contentType={JSON.parse(item.title).name} setContentType={setContentType} />
                    )
                }))}
            {(userType === 'company') &&
                (item.data.map((subItem, index) => {
                    return (
                        <div>
                            <ContentDetailsCompany subItem={subItem} type={JSON.parse(item.title).name.split(' ')[0]} setShowDispute={setShowDispute} activeIndex={index} setActiveIndex={setActiveIndex} setShowCarousel={setShowCarousel} setContentIndex={setContentIndex} contentIndex={contentIndex} contentType={JSON.parse(item.title).name} setContentType={setContentType} />
                        </div>
                    )
                }))}
        </td>
    </tr>)
}